<div class="inspection-dialog">
  <!-- Dialog header -->
  <div class="inspection-dialog-header flex-between-center">
    <div class="flex-start-center w-100">
      <i class="fal fa-ballot-check font-gray-45"></i>

      <div class="service-inspection-title flex-start-center w-100">
        <p class="font-bold m-0 ml-2 ellipsis" tooltipPosition="top" [pTooltip]="inspection.title">{{companyLocalization
          &&
          inspection.titleFr && currentLang
          ==='fr'? inspection?.titleFr: inspection?.title}}</p>
        <div class="h-line ml-1 mr-1"></div>
        <p class="m-0 font-4c">{{ categoryItemText }}</p>
      </div>
    </div>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <!-- Dialog body -->
  <div class="inspection-dialog-body width-100p">
    <div class="inspection-dialog-wrapper-body row">
      <div [ngClass]="isDVIRecommendation?'col-7':'col-12'">
        <!-- When flag is off  -->
        <div class="is-dvi-recommendation-off" *ngIf="!isDVIRecommendation">
          <div *ngFor="let category of inspection?.category" class="mb-3 width-100p">
            <app-inspection-category [workStatus]="workStatus" [isArchived]="isArchived" [isFinalized]="isFinalized"
              [category]="category"></app-inspection-category>
          </div>
        </div>

        <!-- When flag is On  -->
        <div class="is-dvi-recommendation-on pt-3" *ngIf="isDVIRecommendation">
          <div class="flex-between-center mb-2">
            <div class="d-flex">
              <span class="header-status"> Health Statuses: </span>
              <div class="flex-center-center">
                <span class="dotted-green ml-2 mr-1"></span>
                <span class="font-12 font-primary-600">Good</span>
                <span class="dotted-yellow ml-2 mr-1"></span>
                <span class="font-12 font-orange">Service Recommendation</span>
                <span class="dotted-red ml-2 mr-1"></span>
                <span class="font-12 font-error">Service Required</span>
              </div>
            </div>
            <div class="d-flex">
              <span class="font-12 font-gray mr-3 flex-center-center"> Inspection Status:&nbsp; </span>
              <app-content-overlay [dropshadow]="true" [showArrow]="true" [closeAfterAction]="true" right="-5%"
                (appHide)="openStatusFilter()" (appShow)="openStatusFilter()">
                <ng-template appTemplate="item">
                  <div class="add-canned-notes flex-between-center">
                    <span class="d-flex">
                      <i class="flex-center-center fa fa-filter mt-1 mr-2"></i>
                      {{ statusFilter }}</span>
                    <i class="flex-center-center fa mt-1" *ngIf="!statusFilter"
                      [ngClass]="[!closeAfterAction ? 'fa-angle-up' : 'fa-angle-down']"></i>

                    <i class="fa fa-times mt-1" *ngIf="statusFilter" (click)="removeFilter()"></i>
                  </div>
                </ng-template>

                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-100px">
                    <div class="d-flex filter-option border-bottom-lightest" *ngFor="let notes of statusServices">
                      <app-radio-button name="apt-status" [selectedValue]="statusFilter"
                        (appChange)="onChange('filter', $event)" [value]="notes.name"> </app-radio-button>
                      {{ notes.name }}
                    </div>
                  </div>
                </ng-template>
              </app-content-overlay>
              <div></div>
            </div>
          </div>
          <div *ngFor="let category of inspection?.category" class="mb-3 width-100p">
            <app-dvi-inspection-category [workStatus]="workStatus" [isArchived]="isArchived"
              [category]="category"></app-dvi-inspection-category>
          </div>
        </div>
      </div>

      <div class="col-5 border-left bg-shade" *ngIf="isDVIRecommendation">
        <div class="right-empty-img-wrapper">
          <div class="right-empty-inner">
            <img src="../../../../assets/img/empty-img-inspection.png" alt="" />
            <div class="empty-img-content">
              <h4>No inspection item selected</h4>
              <p>Select an inspection item requiring future or immediate attention to associate a service with it.</p>
            </div>
          </div>
        </div>
        <div class="right-search-col pt-3">
          <div class="right-search-header">
            <h4>Calipers and Wheel Cylinders</h4>
            <div class="inspection-item-condition flex-between-center">
              <div class="flex-start-center position-relative">
                <a href="javascript:void(0)" class="inline-block p-1">
                  <div class="inspection-item-color good-hover"></div>
                </a><a href="javascript:void(0)" class="inline-block p-1">
                  <div class="inspection-item-color normal-hover"></div>
                </a><a href="javascript:void(0)" class="inline-block p-1">
                  <div class="inspection-item-color bad-hover"></div>
                </a>
              </div>
            </div>
          </div>

          <!-- Search bar -->
          <div class="search-bar-inspection">
            <!-- [value]="searchQuery" (appEnter)="onSearchEnter($event)" (appClear)="searchClear()" (appCompletedMethod)="searchRepairOrder($event)" -->
            <app-auto-complete placeholder="Search" leftIcon="fal fa-search" field="title" theme="border"
              [closeOnSelection]="true" [hasEditableField]="false" [hasCustomEditableField]="false" [autoFocus]="false"
              [hasSearchIcon]="true" scrollHeight="1px">
            </app-auto-complete>
          </div>

          <!-- Tabs -->
          <div class="search-inspection-tabs">
            <div class="tabs-header">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="previously-tab" data-toggle="tab" href="#previously" role="tab"
                    aria-controls="previously" aria-selected="true">Previously Added</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="all-tab" data-toggle="tab" href="#all" role="tab" aria-controls="all"
                    aria-selected="false">All</a>
                </li>
              </ul>

              <div class="add-service">
                <i class="fal fa-plus"></i>
                <span class="font-600 pl-1">Service</span>
              </div>
            </div>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="previously" role="tabpanel" aria-labelledby="previously-tab">
                <div class="accordion-header">
                  <h3>Motor</h3>
                </div>
                <div id="accordion">
                  <div class="inspection-accordion-wrapper">
                    <h5 class="mb-0" id="services-accordion">
                      <div class="inspection-accordion-btn" data-toggle="collapse" data-target="#collapseOne"
                        aria-expanded="false" aria-controls="collapseOne">
                        <div class="service-chevron">
                          <i class="far fa-chevron-down"></i>
                        </div>
                        <div class="inspection-service-title">
                          <h5 class="one-line-elipsis">ABS System Diagnosis</h5>
                        </div>
                        <div class="inspection-service-count">Adding 5 times</div>
                        <div class="service-total-amount">
                          <p>Subtotal</p>
                          <b>$1,918.30</b>
                        </div>
                        <div class="service-add-btn">
                          <i class="far fa-plus"></i>
                        </div>
                      </div>
                    </h5>
                    <div id="collapseOne" class="collapse" aria-labelledby="services-accordion"
                      data-parent="#accordion">asd asd asd asd ads</div>
                  </div>
                  <div class="inspection-accordion-wrapper">
                    <h5 class="mb-0" id="services-accordion-1">
                      <div class="inspection-accordion-btn" data-toggle="collapse" data-target="#service-1"
                        aria-expanded="false" aria-controls="service-1">
                        <div class="service-chevron">
                          <i class="far fa-chevron-down"></i>
                        </div>
                        <div class="inspection-service-title">
                          <h5 class="one-line-elipsis">Convenience & general</h5>
                        </div>
                        <div class="inspection-service-count">Adding 5 times</div>
                        <div class="service-total-amount">
                          <p>Subtotal</p>
                          <b>$1,918.30</b>
                        </div>
                        <div class="service-add-btn minus">
                          <i class="far fa-minus"></i>
                        </div>
                      </div>
                    </h5>
                    <div id="service-1" class="collapse" aria-labelledby="services-accordion-1"
                      data-parent="#accordion">
                      <div class="inner-accordion-wrapper">
                        <div class="inner-checkbox-wrapper">
                          <app-checkbox inputId="cb-sms-template"> </app-checkbox>
                        </div>
                        <div class="inner-service-title">
                          <p class="one-line-elipsis">Air Bag Impact Sensor</p>
                          <div class="one-line-elipsis sub-title">#8745151 - Front - Japan built</div>
                        </div>
                        <div class="inner-service-type">
                          <p>Type</p>
                          <span>Part</span>
                        </div>
                        <div class="inner-service-price">
                          <p>Price</p>
                          <span>$1,22.28</span>
                        </div>
                        <div class="inner-service-qty">
                          <p>Qty</p>
                          <span>1 unit</span>
                        </div>
                        <div class="inner-service-amount">
                          <p>Amount</p>
                          <span>$1,257.25</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="all" role="tabpanel" aria-labelledby="all-tab">...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog footer -->
  <div class="inspection-dialog-footer" [ngClass]="showUnsavedChanges() ? 'flex-between-center' : 'flex-end-center'">
    <!-- When flag is off  -->
    <div class="is-dvi-recommendation-off" *ngIf="!isDVIRecommendation">
      <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
      <button class="btn btn-primary btn-submit" [ngClass]="{ 'pr-2': isUpdating }"
        [disabled]="isUpdating || workStatus === 'inprogress' || isArchived" (click)="handleSubmit()">
        Save
        <i class="fal fa-spinner rotate" *ngIf="isUpdating"></i>
      </button>
    </div>

    <!-- When flag is On  -->
    <div class="is-dvi-recommendation-on" *ngIf="isDVIRecommendation">
      <div class="font-red font-14" *ngIf="showUnsavedChanges()">You have unsaved changes; once all changes are made,
        please save to retain progress</div>
      <div>
        <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Discard changes</button>
        <button class="btn btn-primary btn-submit" [ngClass]="{ 'pr-2': isUpdating }"
          [disabled]="isUpdating || workStatus === 'inprogress' || isArchived" (click)="handleSubmit()">
          Save and add (5) services
          <i class="fal fa-spinner rotate" *ngIf="isUpdating"></i>
        </button>
      </div>
    </div>
  </div>
</div>